import React, { useCallback, useEffect, useRef } from 'react';
function getEndTime(): number {
  try {
    const saved = localStorage.getItem('megapack_countdown_end');
    if (saved) {
      const t = parseInt(saved, 10);
      if (t > Date.now()) return t;
    }
  } catch {}
  const t = Date.now() + 23 * 3600000 + 58 * 60000 + 33000;
  try {
    localStorage.setItem('megapack_countdown_end', t.toString());
  } catch {}
  return t;
}
export function CountdownSection() {
  const endTimeRef = useRef(0);
  const hRef = useRef<HTMLSpanElement>(null);
  const mRef = useRef<HTMLSpanElement>(null);
  const sRef = useRef<HTMLSpanElement>(null);
  const initRef = useRef(false);
  const update = useCallback(() => {
    const d = endTimeRef.current - Date.now();
    const h = d <= 0 ? '00' : String(Math.floor(d / 3600000 % 24)).padStart(2, '0');
    const m = d <= 0 ? '00' : String(Math.floor(d / 60000 % 60)).padStart(2, '0');
    const s = d <= 0 ? '00' : String(Math.floor(d / 1000 % 60)).padStart(2, '0');
    if (hRef.current) hRef.current.textContent = h;
    if (mRef.current) mRef.current.textContent = m;
    if (sRef.current) sRef.current.textContent = s;
  }, []);
  useEffect(() => {
    if (!initRef.current) {
      endTimeRef.current = getEndTime();
      initRef.current = true;
      update();
    }
    const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, [update]);
  return <section className="text-white py-24 px-4 relative border-t border-[#FF1E00]/10" style={{
    background: 'linear-gradient(180deg, #2A0E0E 0%, #1A0808 40%, #110505 100%)'
  }} data-id="element-34">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-35">
        <h2 className="text-3xl md:text-5xl font-heading font-bold mb-12 md:mb-16 uppercase tracking-wide" data-id="element-36">
          ⏰ EL PRECIO DE
          <br className="md:hidden" data-id="element-37" /> LANZAMIENTO TERMINA EN:
        </h2>
        <div className="flex justify-center items-start gap-2 md:gap-6 mb-16 md:mb-24" data-id="element-38">
          <div className="flex flex-col items-center" data-id="element-39">
            <span ref={hRef} className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-40">
              23
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-41">
              HS
            </span>
          </div>
          <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-42">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-43">
            <span ref={mRef} className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-44">
              58
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-45">
              MIN
            </span>
          </div>
          <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-46">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-47">
            <span ref={sRef} className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-48">
              33
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-49">
              SEG
            </span>
          </div>
        </div>
        <p className="text-2xl md:text-4xl font-bold mb-20 md:mb-28" data-id="element-50">
          Después sube <span className="text-[#FF1E00]" data-id="element-51">$10.000 ARS</span> y no
          vuelve a bajar.
        </p>
        <div className="max-w-3xl mx-auto w-full mb-12" data-id="element-52">
          <div className="flex justify-between items-end mb-4 px-1" data-id="element-53">
            <div className="flex items-center gap-3" data-id="element-54">
              <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#FF1E00]" data-id="element-55"></div>
              <span className="text-[#FF1E00] font-bold text-lg md:text-2xl tracking-tight" data-id="element-56">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-white font-bold text-lg md:text-2xl tracking-tight" data-id="element-57">
              Quedan pocos
            </span>
          </div>
          <div className="w-full h-5 md:h-6 bg-[#2A3441] rounded-full overflow-hidden mb-3" data-id="element-58">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF1E00] to-[#FF6B00]" style={{
            width: '68%'
          }} data-id="element-59" />
          </div>
          <div className="text-right text-white/70 text-sm md:text-base font-medium" data-id="element-60">
            68% de los cupos tomados
          </div>
        </div>
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full max-w-3xl mx-auto bg-brand-accent text-brand-dark hover:bg-brand-accent-dim font-heading font-black text-2xl md:text-3xl py-6 md:py-8 px-8 rounded-2xl transition-colors flex items-center justify-center gap-3" data-id="element-61">
          → ASEGURAR MI PRECIO AHORA
        </button>
      </div>
    </section>;
}